export const rarities = [
  {
    "id": 0,
    "rarity": "Rare"
  },
  {
    "id": 1,
    "rarity": "Rare"
  },
  {
    "id": 2,
    "rarity": "Rare"
  },
  {
    "id": 3,
    "rarity": "Rare"
  },
  {
    "id": 4,
    "rarity": "Epic"
  },
  {
    "id": 5,
    "rarity": "Epic"
  },
  {
    "id": 6,
    "rarity": "Rare"
  },
  {
    "id": 7,
    "rarity": "Epic"
  },
  {
    "id": 8,
    "rarity": "Epic"
  },
  {
    "id": 9,
    "rarity": "Legendary"
  },
  {
    "id": 10,
    "rarity": "Rare"
  },
  {
    "id": 11,
    "rarity": "Rare"
  },
  {
    "id": 12,
    "rarity": "Epic"
  },
  {
    "id": 13,
    "rarity": "Rare"
  },
  {
    "id": 14,
    "rarity": "Rare"
  },
  {
    "id": 15,
    "rarity": "Rare"
  },
  {
    "id": 16,
    "rarity": "Epic"
  },
  {
    "id": 17,
    "rarity": "Epic"
  },
  {
    "id": 18,
    "rarity": "Rare"
  },
  {
    "id": 19,
    "rarity": "Rare"
  },
  {
    "id": 20,
    "rarity": "Mythical"
  },
  {
    "id": 21,
    "rarity": "Rare"
  },
  {
    "id": 22,
    "rarity": "Epic"
  },
  {
    "id": 23,
    "rarity": "Rare"
  },
  {
    "id": 24,
    "rarity": "Epic"
  },
  {
    "id": 25,
    "rarity": "Legendary"
  },
  {
    "id": 26,
    "rarity": "Rare"
  },
  {
    "id": 27,
    "rarity": "Rare"
  },
  {
    "id": 28,
    "rarity": "Epic"
  },
  {
    "id": 29,
    "rarity": "Rare"
  },
  {
    "id": 30,
    "rarity": "Rare"
  },
  {
    "id": 31,
    "rarity": "Epic"
  },
  {
    "id": 32,
    "rarity": "Epic"
  },
  {
    "id": 33,
    "rarity": "Epic"
  },
  {
    "id": 34,
    "rarity": "Epic"
  },
  {
    "id": 35,
    "rarity": "Legendary"
  },
  {
    "id": 36,
    "rarity": "Epic"
  },
  {
    "id": 37,
    "rarity": "Rare"
  },
  {
    "id": 38,
    "rarity": "Rare"
  },
  {
    "id": 39,
    "rarity": "Rare"
  },
  {
    "id": 40,
    "rarity": "Epic"
  },
  {
    "id": 41,
    "rarity": "Rare"
  },
  {
    "id": 42,
    "rarity": "Rare"
  },
  {
    "id": 43,
    "rarity": "Rare"
  },
  {
    "id": 44,
    "rarity": "Rare"
  },
  {
    "id": 45,
    "rarity": "Rare"
  },
  {
    "id": 46,
    "rarity": "Rare"
  },
  {
    "id": 47,
    "rarity": "Rare"
  },
  {
    "id": 48,
    "rarity": "Rare"
  },
  {
    "id": 49,
    "rarity": "Epic"
  },
  {
    "id": 50,
    "rarity": "Rare"
  },
  {
    "id": 51,
    "rarity": "Rare"
  },
  {
    "id": 52,
    "rarity": "Epic"
  },
  {
    "id": 53,
    "rarity": "Rare"
  },
  {
    "id": 54,
    "rarity": "Epic"
  },
  {
    "id": 55,
    "rarity": "Epic"
  },
  {
    "id": 56,
    "rarity": "Rare"
  },
  {
    "id": 57,
    "rarity": "Rare"
  },
  {
    "id": 58,
    "rarity": "Epic"
  },
  {
    "id": 59,
    "rarity": "Rare"
  },
  {
    "id": 60,
    "rarity": "Rare"
  },
  {
    "id": 61,
    "rarity": "Rare"
  },
  {
    "id": 62,
    "rarity": "Rare"
  },
  {
    "id": 63,
    "rarity": "Rare"
  },
  {
    "id": 64,
    "rarity": "Epic"
  },
  {
    "id": 65,
    "rarity": "Rare"
  },
  {
    "id": 66,
    "rarity": "Rare"
  },
  {
    "id": 67,
    "rarity": "Epic"
  },
  {
    "id": 68,
    "rarity": "Rare"
  },
  {
    "id": 69,
    "rarity": "Legendary"
  },
  {
    "id": 70,
    "rarity": "Rare"
  },
  {
    "id": 71,
    "rarity": "Rare"
  },
  {
    "id": 72,
    "rarity": "Rare"
  },
  {
    "id": 73,
    "rarity": "Rare"
  },
  {
    "id": 74,
    "rarity": "Epic"
  },
  {
    "id": 75,
    "rarity": "Epic"
  },
  {
    "id": 76,
    "rarity": "Rare"
  },
  {
    "id": 77,
    "rarity": "Rare"
  },
  {
    "id": 78,
    "rarity": "Rare"
  },
  {
    "id": 79,
    "rarity": "Epic"
  },
  {
    "id": 80,
    "rarity": "Mythical"
  },
  {
    "id": 81,
    "rarity": "Epic"
  },
  {
    "id": 82,
    "rarity": "Rare"
  },
  {
    "id": 83,
    "rarity": "Rare"
  },
  {
    "id": 84,
    "rarity": "Epic"
  },
  {
    "id": 85,
    "rarity": "Epic"
  },
  {
    "id": 86,
    "rarity": "Rare"
  },
  {
    "id": 87,
    "rarity": "Epic"
  },
  {
    "id": 88,
    "rarity": "Epic"
  },
  {
    "id": 89,
    "rarity": "Rare"
  },
  {
    "id": 90,
    "rarity": "Epic"
  },
  {
    "id": 91,
    "rarity": "Epic"
  },
  {
    "id": 92,
    "rarity": "Rare"
  },
  {
    "id": 93,
    "rarity": "Epic"
  },
  {
    "id": 94,
    "rarity": "Epic"
  },
  {
    "id": 95,
    "rarity": "Epic"
  },
  {
    "id": 96,
    "rarity": "Legendary"
  },
  {
    "id": 97,
    "rarity": "Rare"
  },
  {
    "id": 98,
    "rarity": "Epic"
  },
  {
    "id": 99,
    "rarity": "Rare"
  },
  {
    "id": 100,
    "rarity": "Epic"
  },
  {
    "id": 101,
    "rarity": "Rare"
  },
  {
    "id": 102,
    "rarity": "Epic"
  },
  {
    "id": 103,
    "rarity": "Rare"
  },
  {
    "id": 104,
    "rarity": "Rare"
  },
  {
    "id": 105,
    "rarity": "Rare"
  },
  {
    "id": 106,
    "rarity": "Rare"
  },
  {
    "id": 107,
    "rarity": "Rare"
  },
  {
    "id": 108,
    "rarity": "Rare"
  },
  {
    "id": 109,
    "rarity": "Rare"
  },
  {
    "id": 110,
    "rarity": "Rare"
  },
  {
    "id": 111,
    "rarity": "Epic"
  },
  {
    "id": 112,
    "rarity": "Epic"
  },
  {
    "id": 113,
    "rarity": "Rare"
  },
  {
    "id": 114,
    "rarity": "Epic"
  },
  {
    "id": 115,
    "rarity": "Epic"
  },
  {
    "id": 116,
    "rarity": "Rare"
  },
  {
    "id": 117,
    "rarity": "Rare"
  },
  {
    "id": 118,
    "rarity": "Rare"
  },
  {
    "id": 119,
    "rarity": "Rare"
  },
  {
    "id": 120,
    "rarity": "Rare"
  },
  {
    "id": 121,
    "rarity": "Rare"
  },
  {
    "id": 122,
    "rarity": "Epic"
  },
  {
    "id": 123,
    "rarity": "Rare"
  },
  {
    "id": 124,
    "rarity": "Rare"
  },
  {
    "id": 125,
    "rarity": "Epic"
  },
  {
    "id": 126,
    "rarity": "Mythical"
  },
  {
    "id": 127,
    "rarity": "Epic"
  },
  {
    "id": 128,
    "rarity": "Epic"
  },
  {
    "id": 129,
    "rarity": "Epic"
  },
  {
    "id": 130,
    "rarity": "Rare"
  },
  {
    "id": 131,
    "rarity": "Epic"
  },
  {
    "id": 132,
    "rarity": "Epic"
  },
  {
    "id": 133,
    "rarity": "Rare"
  },
  {
    "id": 134,
    "rarity": "Legendary"
  },
  {
    "id": 135,
    "rarity": "Rare"
  },
  {
    "id": 136,
    "rarity": "Rare"
  },
  {
    "id": 137,
    "rarity": "Rare"
  },
  {
    "id": 138,
    "rarity": "Epic"
  },
  {
    "id": 139,
    "rarity": "Rare"
  },
  {
    "id": 140,
    "rarity": "Rare"
  },
  {
    "id": 141,
    "rarity": "Rare"
  },
  {
    "id": 142,
    "rarity": "Rare"
  },
  {
    "id": 143,
    "rarity": "Rare"
  },
  {
    "id": 144,
    "rarity": "Epic"
  },
  {
    "id": 145,
    "rarity": "Rare"
  },
  {
    "id": 146,
    "rarity": "Epic"
  },
  {
    "id": 147,
    "rarity": "Epic"
  },
  {
    "id": 148,
    "rarity": "Legendary"
  },
  {
    "id": 149,
    "rarity": "Rare"
  },
  {
    "id": 150,
    "rarity": "Rare"
  },
  {
    "id": 151,
    "rarity": "Epic"
  },
  {
    "id": 152,
    "rarity": "Rare"
  },
  {
    "id": 153,
    "rarity": "Rare"
  },
  {
    "id": 154,
    "rarity": "Epic"
  },
  {
    "id": 155,
    "rarity": "Epic"
  },
  {
    "id": 156,
    "rarity": "Rare"
  },
  {
    "id": 157,
    "rarity": "Rare"
  },
  {
    "id": 158,
    "rarity": "Epic"
  },
  {
    "id": 159,
    "rarity": "Epic"
  },
  {
    "id": 160,
    "rarity": "Rare"
  },
  {
    "id": 161,
    "rarity": "Rare"
  },
  {
    "id": 162,
    "rarity": "Rare"
  },
  {
    "id": 163,
    "rarity": "Epic"
  },
  {
    "id": 164,
    "rarity": "Rare"
  },
  {
    "id": 165,
    "rarity": "Epic"
  },
  {
    "id": 166,
    "rarity": "Rare"
  },
  {
    "id": 167,
    "rarity": "Rare"
  },
  {
    "id": 168,
    "rarity": "Rare"
  },
  {
    "id": 169,
    "rarity": "Rare"
  },
  {
    "id": 170,
    "rarity": "Legendary"
  },
  {
    "id": 171,
    "rarity": "Rare"
  },
  {
    "id": 172,
    "rarity": "Epic"
  },
  {
    "id": 173,
    "rarity": "Rare"
  },
  {
    "id": 174,
    "rarity": "Epic"
  },
  {
    "id": 175,
    "rarity": "Rare"
  },
  {
    "id": 176,
    "rarity": "Rare"
  },
  {
    "id": 177,
    "rarity": "Rare"
  },
  {
    "id": 178,
    "rarity": "Epic"
  },
  {
    "id": 179,
    "rarity": "Epic"
  },
  {
    "id": 180,
    "rarity": "Legendary"
  },
  {
    "id": 181,
    "rarity": "Rare"
  },
  {
    "id": 182,
    "rarity": "Rare"
  },
  {
    "id": 183,
    "rarity": "Rare"
  },
  {
    "id": 184,
    "rarity": "Rare"
  },
  {
    "id": 185,
    "rarity": "Epic"
  },
  {
    "id": 186,
    "rarity": "Epic"
  },
  {
    "id": 187,
    "rarity": "Epic"
  },
  {
    "id": 188,
    "rarity": "Rare"
  },
  {
    "id": 189,
    "rarity": "Epic"
  },
  {
    "id": 190,
    "rarity": "Rare"
  },
  {
    "id": 191,
    "rarity": "Rare"
  },
  {
    "id": 192,
    "rarity": "Rare"
  },
  {
    "id": 193,
    "rarity": "Rare"
  },
  {
    "id": 194,
    "rarity": "Epic"
  },
  {
    "id": 195,
    "rarity": "Epic"
  },
  {
    "id": 196,
    "rarity": "Rare"
  },
  {
    "id": 197,
    "rarity": "Rare"
  },
  {
    "id": 198,
    "rarity": "Epic"
  },
  {
    "id": 199,
    "rarity": "Epic"
  },
  {
    "id": 200,
    "rarity": "Epic"
  },
  {
    "id": 201,
    "rarity": "Rare"
  },
  {
    "id": 202,
    "rarity": "Epic"
  },
  {
    "id": 203,
    "rarity": "Rare"
  },
  {
    "id": 204,
    "rarity": "Rare"
  },
  {
    "id": 205,
    "rarity": "Legendary"
  },
  {
    "id": 206,
    "rarity": "Rare"
  },
  {
    "id": 207,
    "rarity": "Rare"
  },
  {
    "id": 208,
    "rarity": "Rare"
  },
  {
    "id": 209,
    "rarity": "Legendary"
  },
  {
    "id": 210,
    "rarity": "Rare"
  },
  {
    "id": 211,
    "rarity": "Rare"
  },
  {
    "id": 212,
    "rarity": "Rare"
  },
  {
    "id": 213,
    "rarity": "Epic"
  },
  {
    "id": 214,
    "rarity": "Epic"
  },
  {
    "id": 215,
    "rarity": "Rare"
  },
  {
    "id": 216,
    "rarity": "Epic"
  },
  {
    "id": 217,
    "rarity": "Legendary"
  },
  {
    "id": 218,
    "rarity": "Epic"
  },
  {
    "id": 219,
    "rarity": "Rare"
  },
  {
    "id": 220,
    "rarity": "Epic"
  },
  {
    "id": 221,
    "rarity": "Epic"
  },
  {
    "id": 222,
    "rarity": "Epic"
  },
  {
    "id": 223,
    "rarity": "Rare"
  },
  {
    "id": 224,
    "rarity": "Epic"
  },
  {
    "id": 225,
    "rarity": "Epic"
  },
  {
    "id": 226,
    "rarity": "Rare"
  },
  {
    "id": 227,
    "rarity": "Epic"
  },
  {
    "id": 228,
    "rarity": "Rare"
  },
  {
    "id": 229,
    "rarity": "Rare"
  },
  {
    "id": 230,
    "rarity": "Rare"
  },
  {
    "id": 231,
    "rarity": "Epic"
  },
  {
    "id": 232,
    "rarity": "Rare"
  },
  {
    "id": 233,
    "rarity": "Rare"
  },
  {
    "id": 234,
    "rarity": "Legendary"
  },
  {
    "id": 235,
    "rarity": "Rare"
  },
  {
    "id": 236,
    "rarity": "Rare"
  },
  {
    "id": 237,
    "rarity": "Rare"
  },
  {
    "id": 238,
    "rarity": "Epic"
  },
  {
    "id": 239,
    "rarity": "Epic"
  },
  {
    "id": 240,
    "rarity": "Mythical"
  },
  {
    "id": 241,
    "rarity": "Rare"
  },
  {
    "id": 242,
    "rarity": "Rare"
  },
  {
    "id": 243,
    "rarity": "Epic"
  },
  {
    "id": 244,
    "rarity": "Rare"
  },
  {
    "id": 245,
    "rarity": "Rare"
  },
  {
    "id": 246,
    "rarity": "Epic"
  },
  {
    "id": 247,
    "rarity": "Epic"
  },
  {
    "id": 248,
    "rarity": "Rare"
  },
  {
    "id": 249,
    "rarity": "Epic"
  },
  {
    "id": 250,
    "rarity": "Epic"
  },
  {
    "id": 251,
    "rarity": "Rare"
  },
  {
    "id": 252,
    "rarity": "Epic"
  },
  {
    "id": 253,
    "rarity": "Epic"
  },
  {
    "id": 254,
    "rarity": "Rare"
  },
  {
    "id": 255,
    "rarity": "Rare"
  },
  {
    "id": 256,
    "rarity": "Epic"
  },
  {
    "id": 257,
    "rarity": "Legendary"
  },
  {
    "id": 258,
    "rarity": "Rare"
  },
  {
    "id": 259,
    "rarity": "Rare"
  },
  {
    "id": 260,
    "rarity": "Epic"
  },
  {
    "id": 261,
    "rarity": "Rare"
  },
  {
    "id": 262,
    "rarity": "Rare"
  },
  {
    "id": 263,
    "rarity": "Rare"
  },
  {
    "id": 264,
    "rarity": "Rare"
  },
  {
    "id": 265,
    "rarity": "Epic"
  },
  {
    "id": 266,
    "rarity": "Rare"
  },
  {
    "id": 267,
    "rarity": "Epic"
  },
  {
    "id": 268,
    "rarity": "Rare"
  },
  {
    "id": 269,
    "rarity": "Rare"
  },
  {
    "id": 270,
    "rarity": "Epic"
  },
  {
    "id": 271,
    "rarity": "Rare"
  },
  {
    "id": 272,
    "rarity": "Epic"
  },
  {
    "id": 273,
    "rarity": "Epic"
  },
  {
    "id": 274,
    "rarity": "Rare"
  },
  {
    "id": 275,
    "rarity": "Rare"
  },
  {
    "id": 276,
    "rarity": "Rare"
  },
  {
    "id": 277,
    "rarity": "Rare"
  },
  {
    "id": 278,
    "rarity": "Rare"
  },
  {
    "id": 279,
    "rarity": "Rare"
  },
  {
    "id": 280,
    "rarity": "Rare"
  },
  {
    "id": 281,
    "rarity": "Rare"
  },
  {
    "id": 282,
    "rarity": "Rare"
  },
  {
    "id": 283,
    "rarity": "Legendary"
  },
  {
    "id": 284,
    "rarity": "Rare"
  },
  {
    "id": 285,
    "rarity": "Rare"
  },
  {
    "id": 286,
    "rarity": "Epic"
  },
  {
    "id": 287,
    "rarity": "Mythical"
  },
  {
    "id": 288,
    "rarity": "Legendary"
  },
  {
    "id": 289,
    "rarity": "Rare"
  },
  {
    "id": 290,
    "rarity": "Rare"
  },
  {
    "id": 291,
    "rarity": "Rare"
  },
  {
    "id": 292,
    "rarity": "Rare"
  },
  {
    "id": 293,
    "rarity": "Rare"
  },
  {
    "id": 294,
    "rarity": "Rare"
  },
  {
    "id": 295,
    "rarity": "Rare"
  },
  {
    "id": 296,
    "rarity": "Epic"
  },
  {
    "id": 297,
    "rarity": "Rare"
  },
  {
    "id": 298,
    "rarity": "Epic"
  },
  {
    "id": 299,
    "rarity": "Rare"
  },
  {
    "id": 300,
    "rarity": "Epic"
  },
  {
    "id": 301,
    "rarity": "Rare"
  },
  {
    "id": 302,
    "rarity": "Rare"
  },
  {
    "id": 303,
    "rarity": "Rare"
  },
  {
    "id": 304,
    "rarity": "Rare"
  },
  {
    "id": 305,
    "rarity": "Rare"
  },
  {
    "id": 306,
    "rarity": "Epic"
  },
  {
    "id": 307,
    "rarity": "Rare"
  },
  {
    "id": 308,
    "rarity": "Epic"
  },
  {
    "id": 309,
    "rarity": "Rare"
  },
  {
    "id": 310,
    "rarity": "Rare"
  },
  {
    "id": 311,
    "rarity": "Epic"
  },
  {
    "id": 312,
    "rarity": "Rare"
  },
  {
    "id": 313,
    "rarity": "Legendary"
  },
  {
    "id": 314,
    "rarity": "Rare"
  },
  {
    "id": 315,
    "rarity": "Rare"
  },
  {
    "id": 316,
    "rarity": "Rare"
  },
  {
    "id": 317,
    "rarity": "Epic"
  },
  {
    "id": 318,
    "rarity": "Epic"
  },
  {
    "id": 319,
    "rarity": "Epic"
  },
  {
    "id": 320,
    "rarity": "Rare"
  },
  {
    "id": 321,
    "rarity": "Epic"
  },
  {
    "id": 322,
    "rarity": "Rare"
  },
  {
    "id": 323,
    "rarity": "Rare"
  },
  {
    "id": 324,
    "rarity": "Rare"
  },
  {
    "id": 325,
    "rarity": "Epic"
  },
  {
    "id": 326,
    "rarity": "Epic"
  },
  {
    "id": 327,
    "rarity": "Rare"
  },
  {
    "id": 328,
    "rarity": "Rare"
  },
  {
    "id": 329,
    "rarity": "Rare"
  },
  {
    "id": 330,
    "rarity": "Rare"
  },
  {
    "id": 331,
    "rarity": "Epic"
  },
  {
    "id": 332,
    "rarity": "Epic"
  },
  {
    "id": 333,
    "rarity": "Rare"
  },
  {
    "id": 334,
    "rarity": "Epic"
  },
  {
    "id": 335,
    "rarity": "Epic"
  },
  {
    "id": 336,
    "rarity": "Rare"
  },
  {
    "id": 337,
    "rarity": "Epic"
  },
  {
    "id": 338,
    "rarity": "Rare"
  },
  {
    "id": 339,
    "rarity": "Mythical"
  },
  {
    "id": 340,
    "rarity": "Epic"
  },
  {
    "id": 341,
    "rarity": "Rare"
  },
  {
    "id": 342,
    "rarity": "Rare"
  },
  {
    "id": 343,
    "rarity": "Legendary"
  },
  {
    "id": 344,
    "rarity": "Epic"
  },
  {
    "id": 345,
    "rarity": "Rare"
  },
  {
    "id": 346,
    "rarity": "Rare"
  },
  {
    "id": 347,
    "rarity": "Rare"
  },
  {
    "id": 348,
    "rarity": "Rare"
  },
  {
    "id": 349,
    "rarity": "Rare"
  },
  {
    "id": 350,
    "rarity": "Rare"
  },
  {
    "id": 351,
    "rarity": "Rare"
  },
  {
    "id": 352,
    "rarity": "Rare"
  },
  {
    "id": 353,
    "rarity": "Legendary"
  },
  {
    "id": 354,
    "rarity": "Epic"
  },
  {
    "id": 355,
    "rarity": "Rare"
  },
  {
    "id": 356,
    "rarity": "Legendary"
  },
  {
    "id": 357,
    "rarity": "Epic"
  },
  {
    "id": 358,
    "rarity": "Rare"
  },
  {
    "id": 359,
    "rarity": "Epic"
  },
  {
    "id": 360,
    "rarity": "Rare"
  },
  {
    "id": 361,
    "rarity": "Rare"
  },
  {
    "id": 362,
    "rarity": "Rare"
  },
  {
    "id": 363,
    "rarity": "Epic"
  },
  {
    "id": 364,
    "rarity": "Rare"
  },
  {
    "id": 365,
    "rarity": "Epic"
  },
  {
    "id": 366,
    "rarity": "Rare"
  },
  {
    "id": 367,
    "rarity": "Epic"
  },
  {
    "id": 368,
    "rarity": "Rare"
  },
  {
    "id": 369,
    "rarity": "Rare"
  },
  {
    "id": 370,
    "rarity": "Rare"
  },
  {
    "id": 371,
    "rarity": "Epic"
  },
  {
    "id": 372,
    "rarity": "Epic"
  },
  {
    "id": 373,
    "rarity": "Epic"
  },
  {
    "id": 374,
    "rarity": "Rare"
  },
  {
    "id": 375,
    "rarity": "Rare"
  },
  {
    "id": 376,
    "rarity": "Rare"
  },
  {
    "id": 377,
    "rarity": "Rare"
  },
  {
    "id": 378,
    "rarity": "Epic"
  },
  {
    "id": 379,
    "rarity": "Rare"
  },
  {
    "id": 380,
    "rarity": "Rare"
  },
  {
    "id": 381,
    "rarity": "Epic"
  },
  {
    "id": 382,
    "rarity": "Epic"
  },
  {
    "id": 383,
    "rarity": "Mythical"
  },
  {
    "id": 384,
    "rarity": "Epic"
  },
  {
    "id": 385,
    "rarity": "Rare"
  },
  {
    "id": 386,
    "rarity": "Rare"
  },
  {
    "id": 387,
    "rarity": "Rare"
  },
  {
    "id": 388,
    "rarity": "Rare"
  },
  {
    "id": 389,
    "rarity": "Epic"
  },
  {
    "id": 390,
    "rarity": "Epic"
  },
  {
    "id": 391,
    "rarity": "Rare"
  },
  {
    "id": 392,
    "rarity": "Epic"
  },
  {
    "id": 393,
    "rarity": "Epic"
  },
  {
    "id": 394,
    "rarity": "Rare"
  },
  {
    "id": 395,
    "rarity": "Rare"
  },
  {
    "id": 396,
    "rarity": "Epic"
  },
  {
    "id": 397,
    "rarity": "Epic"
  },
  {
    "id": 398,
    "rarity": "Rare"
  },
  {
    "id": 399,
    "rarity": "Epic"
  },
  {
    "id": 400,
    "rarity": "Rare"
  },
  {
    "id": 401,
    "rarity": "Epic"
  },
  {
    "id": 402,
    "rarity": "Rare"
  },
  {
    "id": 403,
    "rarity": "Rare"
  },
  {
    "id": 404,
    "rarity": "Rare"
  },
  {
    "id": 405,
    "rarity": "Epic"
  },
  {
    "id": 406,
    "rarity": "Rare"
  },
  {
    "id": 407,
    "rarity": "Rare"
  },
  {
    "id": 408,
    "rarity": "Epic"
  },
  {
    "id": 409,
    "rarity": "Rare"
  },
  {
    "id": 410,
    "rarity": "Epic"
  },
  {
    "id": 411,
    "rarity": "Rare"
  },
  {
    "id": 412,
    "rarity": "Epic"
  },
  {
    "id": 413,
    "rarity": "Rare"
  },
  {
    "id": 414,
    "rarity": "Epic"
  },
  {
    "id": 415,
    "rarity": "Rare"
  },
  {
    "id": 416,
    "rarity": "Epic"
  },
  {
    "id": 417,
    "rarity": "Rare"
  },
  {
    "id": 418,
    "rarity": "Epic"
  },
  {
    "id": 419,
    "rarity": "Rare"
  },
  {
    "id": 420,
    "rarity": "Legendary"
  },
  {
    "id": 421,
    "rarity": "Rare"
  },
  {
    "id": 422,
    "rarity": "Epic"
  },
  {
    "id": 423,
    "rarity": "Epic"
  },
  {
    "id": 424,
    "rarity": "Rare"
  },
  {
    "id": 425,
    "rarity": "Epic"
  },
  {
    "id": 426,
    "rarity": "Rare"
  },
  {
    "id": 427,
    "rarity": "Epic"
  },
  {
    "id": 428,
    "rarity": "Legendary"
  },
  {
    "id": 429,
    "rarity": "Epic"
  },
  {
    "id": 430,
    "rarity": "Epic"
  },
  {
    "id": 431,
    "rarity": "Legendary"
  },
  {
    "id": 432,
    "rarity": "Epic"
  },
  {
    "id": 433,
    "rarity": "Rare"
  },
  {
    "id": 434,
    "rarity": "Epic"
  },
  {
    "id": 435,
    "rarity": "Rare"
  },
  {
    "id": 436,
    "rarity": "Epic"
  },
  {
    "id": 437,
    "rarity": "Epic"
  },
  {
    "id": 438,
    "rarity": "Legendary"
  },
  {
    "id": 439,
    "rarity": "Rare"
  },
  {
    "id": 440,
    "rarity": "Rare"
  },
  {
    "id": 441,
    "rarity": "Rare"
  },
  {
    "id": 442,
    "rarity": "Epic"
  },
  {
    "id": 443,
    "rarity": "Epic"
  },
  {
    "id": 444,
    "rarity": "Rare"
  },
  {
    "id": 445,
    "rarity": "Rare"
  },
  {
    "id": 446,
    "rarity": "Rare"
  },
  {
    "id": 447,
    "rarity": "Rare"
  },
  {
    "id": 448,
    "rarity": "Rare"
  },
  {
    "id": 449,
    "rarity": "Mythical"
  },
  {
    "id": 450,
    "rarity": "Epic"
  },
  {
    "id": 451,
    "rarity": "Rare"
  },
  {
    "id": 452,
    "rarity": "Epic"
  },
  {
    "id": 453,
    "rarity": "Epic"
  },
  {
    "id": 454,
    "rarity": "Rare"
  },
  {
    "id": 455,
    "rarity": "Epic"
  },
  {
    "id": 456,
    "rarity": "Legendary"
  },
  {
    "id": 457,
    "rarity": "Epic"
  },
  {
    "id": 458,
    "rarity": "Epic"
  },
  {
    "id": 459,
    "rarity": "Epic"
  },
  {
    "id": 460,
    "rarity": "Rare"
  },
  {
    "id": 461,
    "rarity": "Rare"
  },
  {
    "id": 462,
    "rarity": "Epic"
  },
  {
    "id": 463,
    "rarity": "Rare"
  },
  {
    "id": 464,
    "rarity": "Epic"
  },
  {
    "id": 465,
    "rarity": "Rare"
  },
  {
    "id": 466,
    "rarity": "Rare"
  },
  {
    "id": 467,
    "rarity": "Epic"
  },
  {
    "id": 468,
    "rarity": "Epic"
  },
  {
    "id": 469,
    "rarity": "Rare"
  },
  {
    "id": 470,
    "rarity": "Epic"
  },
  {
    "id": 471,
    "rarity": "Rare"
  },
  {
    "id": 472,
    "rarity": "Rare"
  },
  {
    "id": 473,
    "rarity": "Epic"
  },
  {
    "id": 474,
    "rarity": "Rare"
  },
  {
    "id": 475,
    "rarity": "Epic"
  },
  {
    "id": 476,
    "rarity": "Epic"
  },
  {
    "id": 477,
    "rarity": "Epic"
  },
  {
    "id": 478,
    "rarity": "Legendary"
  },
  {
    "id": 479,
    "rarity": "Epic"
  },
  {
    "id": 480,
    "rarity": "Epic"
  },
  {
    "id": 481,
    "rarity": "Rare"
  },
  {
    "id": 482,
    "rarity": "Rare"
  },
  {
    "id": 483,
    "rarity": "Epic"
  },
  {
    "id": 484,
    "rarity": "Rare"
  },
  {
    "id": 485,
    "rarity": "Rare"
  },
  {
    "id": 486,
    "rarity": "Rare"
  },
  {
    "id": 487,
    "rarity": "Epic"
  },
  {
    "id": 488,
    "rarity": "Epic"
  },
  {
    "id": 489,
    "rarity": "Rare"
  },
  {
    "id": 490,
    "rarity": "Rare"
  },
  {
    "id": 491,
    "rarity": "Epic"
  },
  {
    "id": 492,
    "rarity": "Epic"
  },
  {
    "id": 493,
    "rarity": "Epic"
  },
  {
    "id": 494,
    "rarity": "Rare"
  },
  {
    "id": 495,
    "rarity": "Rare"
  },
  {
    "id": 496,
    "rarity": "Rare"
  },
  {
    "id": 497,
    "rarity": "Rare"
  },
  {
    "id": 498,
    "rarity": "Rare"
  },
  {
    "id": 499,
    "rarity": "Rare"
  },
  {
    "id": 500,
    "rarity": "Epic"
  },
  {
    "id": 501,
    "rarity": "Epic"
  },
  {
    "id": 502,
    "rarity": "Epic"
  },
  {
    "id": 503,
    "rarity": "Rare"
  },
  {
    "id": 504,
    "rarity": "Rare"
  },
  {
    "id": 505,
    "rarity": "Rare"
  },
  {
    "id": 506,
    "rarity": "Rare"
  },
  {
    "id": 507,
    "rarity": "Epic"
  },
  {
    "id": 508,
    "rarity": "Rare"
  },
  {
    "id": 509,
    "rarity": "Rare"
  },
  {
    "id": 510,
    "rarity": "Epic"
  },
  {
    "id": 511,
    "rarity": "Rare"
  },
  {
    "id": 512,
    "rarity": "Epic"
  },
  {
    "id": 513,
    "rarity": "Rare"
  },
  {
    "id": 514,
    "rarity": "Epic"
  },
  {
    "id": 515,
    "rarity": "Rare"
  },
  {
    "id": 516,
    "rarity": "Epic"
  },
  {
    "id": 517,
    "rarity": "Epic"
  },
  {
    "id": 518,
    "rarity": "Rare"
  },
  {
    "id": 519,
    "rarity": "Rare"
  },
  {
    "id": 520,
    "rarity": "Epic"
  },
  {
    "id": 521,
    "rarity": "Epic"
  },
  {
    "id": 522,
    "rarity": "Rare"
  },
  {
    "id": 523,
    "rarity": "Legendary"
  },
  {
    "id": 524,
    "rarity": "Epic"
  },
  {
    "id": 525,
    "rarity": "Epic"
  },
  {
    "id": 526,
    "rarity": "Epic"
  },
  {
    "id": 527,
    "rarity": "Rare"
  },
  {
    "id": 528,
    "rarity": "Epic"
  },
  {
    "id": 529,
    "rarity": "Rare"
  },
  {
    "id": 530,
    "rarity": "Epic"
  },
  {
    "id": 531,
    "rarity": "Rare"
  },
  {
    "id": 532,
    "rarity": "Rare"
  },
  {
    "id": 533,
    "rarity": "Rare"
  },
  {
    "id": 534,
    "rarity": "Rare"
  },
  {
    "id": 535,
    "rarity": "Epic"
  },
  {
    "id": 536,
    "rarity": "Rare"
  },
  {
    "id": 537,
    "rarity": "Rare"
  },
  {
    "id": 538,
    "rarity": "Epic"
  },
  {
    "id": 539,
    "rarity": "Epic"
  },
  {
    "id": 540,
    "rarity": "Rare"
  },
  {
    "id": 541,
    "rarity": "Epic"
  },
  {
    "id": 542,
    "rarity": "Epic"
  },
  {
    "id": 543,
    "rarity": "Rare"
  },
  {
    "id": 544,
    "rarity": "Rare"
  },
  {
    "id": 545,
    "rarity": "Epic"
  },
  {
    "id": 546,
    "rarity": "Rare"
  },
  {
    "id": 547,
    "rarity": "Epic"
  },
  {
    "id": 548,
    "rarity": "Rare"
  },
  {
    "id": 549,
    "rarity": "Epic"
  },
  {
    "id": 550,
    "rarity": "Epic"
  },
  {
    "id": 551,
    "rarity": "Rare"
  },
  {
    "id": 552,
    "rarity": "Epic"
  },
  {
    "id": 553,
    "rarity": "Epic"
  },
  {
    "id": 554,
    "rarity": "Epic"
  },
  {
    "id": 555,
    "rarity": "Epic"
  },
  {
    "id": 556,
    "rarity": "Rare"
  },
  {
    "id": 557,
    "rarity": "Rare"
  },
  {
    "id": 558,
    "rarity": "Rare"
  },
  {
    "id": 559,
    "rarity": "Rare"
  },
  {
    "id": 560,
    "rarity": "Legendary"
  },
  {
    "id": 561,
    "rarity": "Rare"
  },
  {
    "id": 562,
    "rarity": "Epic"
  },
  {
    "id": 563,
    "rarity": "Rare"
  },
  {
    "id": 564,
    "rarity": "Epic"
  },
  {
    "id": 565,
    "rarity": "Epic"
  },
  {
    "id": 566,
    "rarity": "Rare"
  },
  {
    "id": 567,
    "rarity": "Rare"
  },
  {
    "id": 568,
    "rarity": "Epic"
  },
  {
    "id": 569,
    "rarity": "Rare"
  },
  {
    "id": 570,
    "rarity": "Epic"
  },
  {
    "id": 571,
    "rarity": "Epic"
  },
  {
    "id": 572,
    "rarity": "Legendary"
  },
  {
    "id": 573,
    "rarity": "Rare"
  },
  {
    "id": 574,
    "rarity": "Epic"
  },
  {
    "id": 575,
    "rarity": "Rare"
  },
  {
    "id": 576,
    "rarity": "Rare"
  },
  {
    "id": 577,
    "rarity": "Epic"
  },
  {
    "id": 578,
    "rarity": "Epic"
  },
  {
    "id": 579,
    "rarity": "Rare"
  },
  {
    "id": 580,
    "rarity": "Epic"
  },
  {
    "id": 581,
    "rarity": "Rare"
  },
  {
    "id": 582,
    "rarity": "Epic"
  },
  {
    "id": 583,
    "rarity": "Rare"
  },
  {
    "id": 584,
    "rarity": "Rare"
  },
  {
    "id": 585,
    "rarity": "Rare"
  },
  {
    "id": 586,
    "rarity": "Epic"
  },
  {
    "id": 587,
    "rarity": "Rare"
  },
  {
    "id": 588,
    "rarity": "Rare"
  },
  {
    "id": 589,
    "rarity": "Mythical"
  },
  {
    "id": 590,
    "rarity": "Rare"
  },
  {
    "id": 591,
    "rarity": "Epic"
  },
  {
    "id": 592,
    "rarity": "Rare"
  },
  {
    "id": 593,
    "rarity": "Legendary"
  },
  {
    "id": 594,
    "rarity": "Rare"
  },
  {
    "id": 595,
    "rarity": "Epic"
  },
  {
    "id": 596,
    "rarity": "Epic"
  },
  {
    "id": 597,
    "rarity": "Epic"
  },
  {
    "id": 598,
    "rarity": "Rare"
  },
  {
    "id": 599,
    "rarity": "Epic"
  }
]